import isEmpty from 'lodash/isEmpty';

export const getWidgetSet = id => (dispatch, getState) => (
    getState().widgetPool.find(widgetSet => widgetSet.config.id === id)
);

export const setConfig = (id, widgetType, config) => async (dispatch) => {
    if (!isEmpty(config)) {
        await dispatch({ type: 'SET_CONFIG', payload: { widgetType, config }, id });
    }
    return dispatch(getWidgetSet(id));
};

export const setLoadingBlocks = (id, loadingBlocksForRates, loadingBlocksForOffers) => (dispatch) => {
    dispatch({ type: 'SET_LOADING_BLOCKS', payload: { loadingBlocksForRates, loadingBlocksForOffers }, id });
};

export const setNumberOfOffers = (id, numberOfOffers) => (dispatch) => {
    dispatch({ type: 'SET_NUMBER_OF_OFFERS', payload: { numberOfOffers }, id });
};

export default setConfig;
